import { CloseIcon } from '@sketchnote/icons';
import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { useBoardStore } from 'src/features/boards';
import { useTasksStore } from 'src/features/tasks/store/useTasksStore';

import { TypeEnum } from '../../../../../features/tasks/types/tasks';
import { useKanbanStore } from '../../../store';
const initialValues = {
  name: [{ children: [{ text: '' }] }],
  createAnother: false,
};

export const CreateTask = ({ startDate, endDate }: { startDate?: Date; endDate?: Date }) => {
  const { onAddNewItem, currentSelectedItem, onCloseCurrentSelectedItem } = useKanbanStore((s) => ({
    onAddNewItem: s.onAddNewItem,
    currentSelectedItem: s.currentSelectedItem,
    onCloseCurrentSelectedItem: s.onCloseCurrentSelectedItem,
  }));

  const { actions } = useBoardStore((s) => ({
    actions: s.actions,
  }));

  const [newTask, setNewTask] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const { tasks, setTask, onUpdateCustomFieldData, onAddCustomField } = useTasksStore();

  useEffect(() => {
    textAreaRef.current?.focus();
  }, []);

  const handleSubmit = async () => {
    if (currentSelectedItem.columnId) {
      const payload: any = {};
      payload.columnKey = currentSelectedItem.columnId;
      payload.name = [{ type: 'p', children: [{ text: newTask }] }];
      if (startDate) {
        if (endDate) {
          payload.assignDate = [startDate, endDate];
        } else {
          payload.assignDate = [startDate];
        }
      }
      currentSelectedItem.top ? (payload.top = true) : '';
      currentSelectedItem.selectedTemplateRef
        ? (payload.taskTemplateRef = currentSelectedItem.selectedTemplateRef)
        : '';

      if (!startDate) setNewTask('');

      const response: any = await onAddNewItem(payload);
      // check if response contains "taskTemplateRef" field
      if (response && payload.taskTemplateRef) {
        // First of all, add the task to the task store
        setTask(response.id, response);
      }

      if (response) {
        actions.incrementTaskCount();
      }
      if (startDate) {
        onCloseCurrentSelectedItem({
          isOpen: false,
          columnId: currentSelectedItem.columnId,
          item: undefined,
          itemIndex: undefined,
          mode: undefined,
        });
      } else {
        onCloseCurrentSelectedItem({
          isOpen: true,
          columnId: currentSelectedItem.columnId,
          item: undefined,
          itemIndex: undefined,
          mode: 'add',
        });
        setNewTask('');
        textAreaRef.current?.focus();
      }
    }
  };

  const handleTaskViewClose = () => {
    onCloseCurrentSelectedItem();
  };

  return (
    <div
      className={cn(
        'p-12 w-full shadow-mdl4 rounded-md text-left flex items-center justify-between bg-white font-regular  text-sm kanban-card',
        {
          'mb-20': currentSelectedItem.top,
        }
      )}
    >
      <TextareaAutosize
        value={newTask}
        ref={textAreaRef}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit();
            e.preventDefault();
          }
        }}
        autoFocus
        placeholder="Untitled task"
        className="w-full resize-none text-sm font-regular"
        onChange={(e) => {
          setNewTask(e.target.value);
        }}
      ></TextareaAutosize>
      {newTask ? (
        <div
          className="bg-blue-500 text-white rounded-sm py-4 px-6 font-medium hover:bg-blue-600 cursor-pointer text-xs"
          onClick={handleSubmit}
        >
          Save
        </div>
      ) : (
        <div className="bg-gray-100 text-gray-400 rounded-sm py-4 px-6 font-medium select-none text-xs">
          Save
        </div>
      )}
      <button onClick={handleTaskViewClose}>
        <CloseIcon className="ml-5 text-gray-500 text-xss" />
      </button>
    </div>
  );
};
